module.exports = __webpack_public_path__ + "static/dcc-fc21ff9fae87ba71a3c23a49cf2d9051.png";